import { Box, Button, TextField, Typography } from '@mui/material'
import { BoxOrderContext } from 'contexts/BoxOrderContextProvider'
import { OrderContext } from 'contexts/OrderContextProvider'
import { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { SnackbarSeverity } from 'constant'
import { SnackContext } from 'contexts/SnackContextProvider'
import { getBatchPrefixFromBoxCode } from 'utils'

const ScanBox = () => {
  const { company } = useParams()
  const [error, setError] = useState(false)
  const [inputBoxCode, setInputBoxCode] = useState('')
  const {
    selectedLocationId,
    selectedDailyOrderBatchIndex,
    filteredDailyOrdersByClass
  } = useContext(OrderContext)
  const { setSelectedRack, handleGetOrCreateBox } = useContext(BoxOrderContext)
  const { handleOpenSnackbar } = useContext(SnackContext)

  const getBatchIndexByLabel = (label?: string | null): number => {
    const normalized = `${label || ''}`.trim().toUpperCase()
    if (!/^[A-Z]+$/.test(normalized)) return Number.MAX_SAFE_INTEGER
    let result = 0
    for (let i = 0; i < normalized.length; i++) {
      result = result * 26 + (normalized.charCodeAt(i) - 64)
    }
    return result - 1
  }
  const batchLabels = Array.from(
    new Set(
      filteredDailyOrdersByClass
        .map(order => `${order?.batchLabel || ''}`.trim().toUpperCase())
        .filter((label: string) => label.length > 0)
    )
  ).sort((a, b) => getBatchIndexByLabel(a) - getBatchIndexByLabel(b))
  const selectedBatchLabel =
    selectedDailyOrderBatchIndex !== undefined
      ? batchLabels[selectedDailyOrderBatchIndex] || ''
      : ''

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      const scannedBoxPrefix = getBatchPrefixFromBoxCode(inputBoxCode)
      if (selectedBatchLabel && scannedBoxPrefix !== selectedBatchLabel) {
        handleOpenSnackbar(
          SnackbarSeverity.Error,
          `Box prefix must match batch ${selectedBatchLabel}`
        )
        return
      }
      handleGetOrCreateBox(inputBoxCode, setError, company, selectedLocationId)
    }
  }
  return (
    <>
      <Button
        variant='outlined'
        onClick={() => {
          setSelectedRack(null)
        }}
        sx={{
          margin: '20px'
        }}
      >
        Back
      </Button>
      <Typography variant='h3' sx={{ textAlign: 'center' }}>
        Scan a Box
      </Typography>
      <Box onKeyDown={handleKeyDown} sx={{ margin: '50px 20px' }}>
        <TextField
          autoFocus
          label='Box Code'
          fullWidth
          value={inputBoxCode}
          error={error}
          helperText={error && 'This field cannot be empty'}
          onChange={e => {
            setError(false)
            setInputBoxCode(e.target.value)
          }}
        />
      </Box>
    </>
  )
}
export default ScanBox
